<script type="text/javascript">
import $ from 'jquery'

let year = "2023sh";
let companyphone = "400-8128-020";
// let companyphone = "139-2085-9305";
let timestamp = 24*60*60*1000;

let hashParam = {};
let popupClose = false;
let popupTime = false;
let popupCloseLive = false;
let popupTimeLive = false;

function getHash() {
  if(window.location.search.length>0){
    window.location.search
    .substr(1)
    .split("&")
    .map(item => {
      const arr = item.split("=");
      hashParam[arr[0]] = arr[1];
    });
  }
  // console.log(hashParam);
}

function getServerTime() {
    return new Date($.ajax({
        type: 'get',
        url: '/',
        async: false
    }).getResponseHeader("Date"));
}

function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : "0" + n;
}
function formatTime(number, format) {
  var formateArr = ["Y", "M", "D", "h", "m", "s"];
  var returnArr = [];
  var date = new Date(number * 1000); // 接口获取的数据一般为时间戳的1/1000
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));
  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));
  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;
}
function getWeek(number) {
  var date = new Date(number * 1000); // 接口获取的数据一般为时间戳的1/1000
  var weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
  return weekArr[date.getDay()];
}

// 对象组成的数组排序 自定义规则 arr.sort(toSort(key, mode, type, primer))
function toSortKey(key, mode, type, primer) {
  /* 
      key    排序用的键名
      mode   1升序 0降序
      type   键值数据类型
      primer 数据的解析，如parseInt
  */
  return function(a, b) {
    a = a[key];
    b = b[key];
    // 避免存在值为null的情况
    if (a && b) {
      // 字符串排序
      if (type == "string") {
        if (mode) {
          return a.localeCompare(b);
        } else {
          return b.localeCompare(a);
        }
      }
      // 数字排序
      if (type == "number") {
        mode = mode ? -1 : 1;
        if (typeof primer != "undefined") {
          a = primer(a);
          b = primer(b);
        }
        if (a < b) {
          return mode * -1;
        }
        if (a > b) {
          return mode * 1;
        }
        return 1;
      }
    }
  };
}

export default {
 year,
 companyphone,
 timestamp,
 hashParam,
 popupClose,
 popupTime,
 popupCloseLive,
 popupTimeLive,
 getHash,
 getServerTime,
 formatTime,
 getWeek,
 toSortKey,
}
</script>